import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Administrator
// Component:
// ----------------------------------------------

//const ADDRS_API = config.COMP_API + '/campaigns';
// const ADDRS_API = config.API + '/advertiseroffers';
const ADDRS_API = config.API;
const FILTER_KEY1 = 'filter-adm-type';
const FILTER_KEY2 = 'filter-adm-device';
const FILTER_KEY3 = 'filter-adm-advertiser';
const FILTER_KEY4 = 'filter-adm-country';
const FILTER_KEY5 = 'filter-adm-button';
const FILTER_KEY6 = 'filter-adm-page';
const FILTER_KEY7 = 'filter-adm-advertiserofferid';

// API description for all commnication with BACK-END for campaigns management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })

  export class OffersService {
    constructor(private http: HttpClient) { }

    // ----------------------------------------------
    // OBSŁUGA LOCKING RULES
    // ADMIN-OFFERS-ALL OFFERS
    // ADMIN-OFFERS-ALL OFFERS-OFFER

    getOffers(filter: any): Observable<any> {
        return this.http.post(`${ADDRS_API}` + '/admin/offers', filter);
      }

    getOffer(offerId: any): Observable<any> {
          return this.http.get(`${ADDRS_API}` + `/admin/offers/` + `${offerId}`);
        }

    // ustaw globalStatus dla oferty
    updateOfferStatus(id: any, data: any): Observable<any> {
          return this.http.put(`${ADDRS_API}` + `/admin/offers/` + `${id}` + `/status`, data);
        }

    // update kilku parametrów oferty
    updateOffer(id: any, setStatus: any): Observable<any> {
      return this.http.put(`${ADDRS_API}` + `/admin/offers/` + `${id}`, setStatus);
    }

    importAllOffers(): Observable<any> {
        return this.http.get(`${ADDRS_API}` + `/advertisersmanagement/offers`);
      }

    importOffers(id: any): Observable<any> {
        return this.http.get(`${ADDRS_API}` + `/advertisersmanagement/`+ `${id}` + `/offers`);
      }

    // ----------------------------------------------
    // OBSŁUGA LOCKING RULES
    // ADMIN-OFFERS-LOCKING RULES

    // pobranie wszystkich locking rules
    getAllRules(): Observable<any> {
          return this.http.get(ADDRS_API + '/admin/locking');
        }

    // usunięcie wszystkich locking rules
    deleteAllRules(): Observable<any> {
          return this.http.delete(`${ADDRS_API}` + `/admin/locking` );
        }

    // usunięcie listy locking rules
    deleteRule(data: any): Observable<any> {
      return this.http.delete(`${ADDRS_API}` + `/admin/locking`, data);
    }

    // dodanie jednej locking rule
    createRule(data: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/locking', data);
    }

    // ----------------------------------------------
    // OBSŁUGA LOCKING RULES
    // ADMIN-OFFERS-IMPORT OFFERS

    // pobranie wszystkich locking rules
    getImport(): Observable<any> {
      return this.http.get(ADDRS_API + '/admin/offers/importoffersstatistics');
    }

    // ----------------------------------------------
    // OBSŁUGA BLACK LIST
    // ADMIN-OFFERS-BLACK LIST

    getBlackList(data: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/offers/black-list', data);
    }

    addBlackList(data: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/offers/black-list/add-offer-to-black-list', data);
    }

    deleteBlackList(id: any): Observable<any> {
      return this.http.delete(ADDRS_API + '/admin/offers/black-list/' + `${id}`);
    }

    // ----------------------------------------------
    // OBSŁUGA SETTINGS
    // ADMIN-OFFERS-SETTINGS

    getTopOffers(size: any): Observable<any> {
      return this.http.get(ADDRS_API + `/admin/offers/stats/`+ `${size}`);
    }

    getMode(): Observable<any> {
      return this.http.get(ADDRS_API + '/admin/offers/mode');
    }

    setMode(mode: any): Observable<any> {
      return this.http.put(ADDRS_API + `/admin/offers/mode`, mode);
    }

    // OBSŁUGA IMPORT FRAUD
    // ADMIN-FAUD IMPORT

    getFraudImport(page: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/fraudimport', page);
    }

    importFraudImport(data: any): Observable<any> {
      return this.http.post(ADDRS_API + '/admin/fraudimport/import', data);
    }

    // ----------------------------------------------
    // OBSŁUGA FILTRÓW
    // ADMIN-OFFERS-ALL OFFERS

    public saveFilter(id: number, filter: any): void {
      switch(id){
        case 1: // filter type (categorise)
          window.sessionStorage.removeItem(FILTER_KEY1);
          window.sessionStorage.setItem(FILTER_KEY1, JSON.stringify(filter));
          break;

        case 2:  // filtr device
          window.sessionStorage.removeItem(FILTER_KEY2);
          window.sessionStorage.setItem(FILTER_KEY2, JSON.stringify(filter));
          break;

        case 3:
          window.sessionStorage.removeItem(FILTER_KEY3);
          window.sessionStorage.setItem(FILTER_KEY3, JSON.stringify(filter));
          break;

        case 4:
          window.sessionStorage.removeItem(FILTER_KEY4);
          window.sessionStorage.setItem(FILTER_KEY4, JSON.stringify(filter));
          break;

        case 5: // button on/off
          window.sessionStorage.removeItem(FILTER_KEY5);
          window.sessionStorage.setItem(FILTER_KEY5, JSON.stringify(filter));
          break;

        case 6:
          window.sessionStorage.removeItem(FILTER_KEY6);
          window.sessionStorage.setItem(FILTER_KEY6, JSON.stringify(filter));
          break;

        case 7: // filtr advertiser offer id
          window.sessionStorage.removeItem(FILTER_KEY7);
          window.sessionStorage.setItem(FILTER_KEY7, JSON.stringify(filter));
          break;
      }
    }

    public getFilter(id: number): any {
      switch(id) {
        case 1: // filter type (categorise)
          const filter1 = window.sessionStorage.getItem(FILTER_KEY1);
          if(filter1)
          {
            return JSON.parse(filter1);
          }
          return null;

        case 2: // filtr device
          const filter2 = window.sessionStorage.getItem(FILTER_KEY2);
          if(filter2)
          {
            return JSON.parse(filter2);
          }
          return null;

        case 3: // filtr advertisers
          const filter3 = window.sessionStorage.getItem(FILTER_KEY3);
          if(filter3)
          {
            return JSON.parse(filter3);
          }
          return null;

        case 4: // filtr country
          const filter4 = window.sessionStorage.getItem(FILTER_KEY4);
          if(filter4)
          {
            return JSON.parse(filter4);
          }
          return null;

        case 5: // button on/off
          const filter5 = window.sessionStorage.getItem(FILTER_KEY5);
          if(filter5)
          {
            return JSON.parse(filter5);
          }
          return null;

        case 6: // offset (page)
          const filter6 = window.sessionStorage.getItem(FILTER_KEY6);
          if(filter6)
          {
            return JSON.parse(filter6);
          }
          return null;

        case 7: // filtr advertisers offer id
        const filter7 = window.sessionStorage.getItem(FILTER_KEY7);
        if(filter7)
        {
          return JSON.parse(filter7);
        }
        return null;
      }
    }
    // ----------------------------------------------

}
